import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/apps/webapp/app/[locale]/(homepage)/(home)/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GNB"] */ "/app/apps/webapp/app/[locale]/(homepage)/(home)/components/GNB.tsx");
